import React, { useState } from "react";
import { ABtn, AResult, AScore } from "./arcadeUi";

const MOVES = [
  { k: "rock", e: "🪨", l: "Rock" },
  { k: "paper", e: "📄", l: "Paper" },
  { k: "scissors", e: "✂️", l: "Scissors" },
];
const beats = { rock: "scissors", paper: "rock", scissors: "paper" };
const E = (k) => MOVES.find((x) => x.k === k)?.e || "❔";

export default function RockPaperScissors() {
  const [you, setYou] = useState(null);
  const [cpu, setCpu] = useState(null);
  const [res, setRes] = useState(null);
  const [s, setS] = useState({ you: 0, cpu: 0 });

  const play = (m) => {
    const c = MOVES[Math.floor(Math.random() * 3)].k;
    setYou(m);
    setCpu(c);
    const r = m === c ? "draw" : beats[m] === c ? "win" : "lose";
    setRes(r);
    setS((p) => ({ you: p.you + (r === "win" ? 1 : 0), cpu: p.cpu + (r === "lose" ? 1 : 0) }));
  };

  return (
    <div className="w-full text-center">
      <div className="flex justify-center gap-2">
        <AScore label="You" value={s.you} />
        <AScore label="CPU" value={s.cpu} />
      </div>
      <div className="my-5 flex items-center justify-center gap-5 sm:gap-8">
        <div className="flex flex-col items-center">
          <span className="text-5xl sm:text-6xl">{you ? E(you) : "❔"}</span>
          <span className="mt-1 text-xs font-bold text-kirana-brown">YOU</span>
        </div>
        <span className="font-signboard text-2xl text-kirana-brown/50">vs</span>
        <div className="flex flex-col items-center">
          <span className="text-5xl sm:text-6xl">{cpu ? E(cpu) : "❔"}</span>
          <span className="mt-1 text-xs font-bold text-kirana-brown">CPU</span>
        </div>
      </div>
      {res && (
        <AResult
          testId="rps-result"
          win={res === "win" ? true : res === "lose" ? false : null}
          text={res === "win" ? "You Win! 🎉" : res === "lose" ? "You Lose 😜" : "It's a Draw 🤝"}
        />
      )}
      <div className="mt-5 flex flex-wrap justify-center gap-2">
        {MOVES.map((m) => (
          <ABtn key={m.k} data-testid={`rps-${m.k}`} onClick={() => play(m.k)} tone="gold" className="text-base">
            {m.e} {m.l}
          </ABtn>
        ))}
      </div>
    </div>
  );
}
